export const STATUS_TYPE_LIBRARY = [
  {
    canonical: 'open',
    aliases: [
      'open', 'opened', 'new', 'created', 'to do', 'todo', 'backlog',
      'incoming', 'logged', 'reported', 'registered', 'submitted',
      'triage', 'triaged', 'ready', 'ready for work', 'queued'
    ],
    operationalType: 'intake',
    timeBucket: 'queue',
    confidence: 0.95,
    flags: {
      isStartState: true,
      isActiveWork: false,
      isWaiting: false,
      isTerminal: false,
      excludeFromFlowEfficiency: true
    }
  },
  {
    canonical: 'in progress',
    aliases: [
      'in progress', 'progress', 'working', 'doing', 'assigned',
      'being worked on', 'implementing', 'implementation', 'investigating',
      'analysis', 'analysing', 'analyzing', 'development', 'developing',
      'building', 'coding', 'fixing', 'troubleshooting', 'diagnosing',
      'resolution in progress', 'wip', 'work in progress', 'processing',
      'fulfilling', 'fulfillment', 'executing'
    ],
    operationalType: 'active',
    timeBucket: 'touch',
    confidence: 0.97,
    flags: {
      isStartState: false,
      isActiveWork: true,
      isWaiting: false,
      isTerminal: false,
      excludeFromFlowEfficiency: false
    }
  },
  {
    canonical: 'pending',
    aliases: [
      'pending', 'on hold', 'hold', 'blocked', 'waiting', 'waiting for info',
      'waiting for information', 'awaiting information', 'awaiting input',
      'awaiting customer', 'waiting for customer', 'customer response',
      'awaiting response', 'waiting for response', 'waiting on requester',
      'awaiting requester', 'awaiting third party', 'waiting for vendor',
      'awaiting vendor', 'awaiting supplier', 'waiting for supplier',
      'awaiting dependency', 'waiting on dependency', 'deferred',
      'parked', 'paused', 'suspended', 'stalled'
    ],
    operationalType: 'waiting',
    timeBucket: 'wait',
    confidence: 0.97,
    flags: {
      isStartState: false,
      isActiveWork: false,
      isWaiting: true,
      isTerminal: false,
      excludeFromFlowEfficiency: false
    }
  },
  {
    canonical: 'review',
    aliases: [
      'review', 'in review', 'peer review', 'code review', 'design review',
      'qa', 'testing', 'test', 'uat', 'validation', 'verify', 'verification',
      'awaiting approval', 'approval', 'change approval', 'cab review',
      'ready for test', 'ready for qa', 'ready for review',
      'ready for validation', 'awaiting qa', 'awaiting review'
    ],
    operationalType: 'review',
    timeBucket: 'touch',
    confidence: 0.84,
    flags: {
      isStartState: false,
      isActiveWork: true,
      isWaiting: false,
      isTerminal: false,
      excludeFromFlowEfficiency: false
    }
  },
  {
    canonical: 'resolved',
    aliases: [
      'resolved', 'done', 'completed', 'complete', 'fixed', 'implemented',
      'delivered', 'ready for closure', 'solution provided', 'fulfilled',
      'work completed', 'service restored', 'restored'
    ],
    operationalType: 'resolved',
    timeBucket: 'admin',
    confidence: 0.90,
    flags: {
      isStartState: false,
      isActiveWork: false,
      isWaiting: false,
      isTerminal: false,
      excludeFromFlowEfficiency: true
    }
  },
  {
    canonical: 'closed',
    aliases: [
      'closed', 'closure', 'finalized', 'finalised', 'finished',
      'archived', 'shipped', 'deployed and closed'
    ],
    operationalType: 'closed',
    timeBucket: 'terminal',
    confidence: 0.98,
    flags: {
      isStartState: false,
      isActiveWork: false,
      isWaiting: false,
      isTerminal: true,
      excludeFromFlowEfficiency: true
    }
  },
  {
    canonical: 'cancelled',
    aliases: [
      'cancelled', 'canceled', 'rejected', 'declined', "won't do", 'wont do',
      'duplicate', 'abandoned', 'withdrawn', 'not approved', 'invalid'
    ],
    operationalType: 'cancelled',
    timeBucket: 'terminal',
    confidence: 0.98,
    flags: {
      isStartState: false,
      isActiveWork: false,
      isWaiting: false,
      isTerminal: true,
      excludeFromFlowEfficiency: true
    }
  }
];
